import { useEffect } from "react";

export function use3DEffect(ref, intensity = 25) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const getRotation = (event) => {
      const rect = el.getBoundingClientRect();
      const x = event.clientX - rect.left - rect.width / 2;
      const y = event.clientY - rect.top - rect.height / 2;
      return { rotateY: x / intensity, rotateX: -y / intensity };
    };

    const apply = (e) => {
      requestAnimationFrame(() => {
        const { rotateX, rotateY } = getRotation(e);
        el.style.transform = `rotateY(${rotateY}deg) rotateX(${rotateX}deg)`;
        el.style.transition = "";
      });
    };

    const reset = () => {
      requestAnimationFrame(() => {
        el.style.transform = "rotateY(0deg) rotateX(0deg)";
        el.style.transition = "transform .3s ease";
      });
    };

    el.addEventListener("mousemove", apply);
    el.addEventListener("mouseleave", reset);

    return () => {
      el.removeEventListener("mousemove", apply);
      el.removeEventListener("mouseleave", reset);
    };
  }, [ref, intensity]);
}